import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = ({ scrolled }) => {
  const { t } = useTranslation();

  return (
    <header id="siteHeader" className={scrolled ? "scrolled" : ""}>
      <div className="brand">
        <div className="logo">
          <img src="/logo.png" alt="Kannan's Astrohub Logo" />
        </div>
        <div>
          <div style={{ fontWeight: 700 }}>{t('header.brand')}</div>
          <div style={{ fontSize: 12, color: "var(--muted)" }}>
            {t('header.subtitle')}
          </div>
        </div>
      </div>

      <div className="mobile-lang">
        <LanguageSwitcher />
      </div>

      <nav aria-label="Main navigation">
        <a href="#services">{t('header.services')}</a>
        <a href="#testimonials">{t('header.testimonials')}</a>
        <a href="#about">{t('header.about')}</a>
        <LanguageSwitcher />
        <a href="#contact" className="cta">
          {t('header.book')}
        </a>
      </nav>
    </header>
  );
};

export default Header;
